<template>
    <application-layout
        :property="property"
        :application="application"
        :experian_attempt="experian_attempt"
        :step_completion_status="$page.props.step_completion_status"
        :step_progress_data="$page.props.step_progress_data"
        :completed_steps_map="$page.props.completed_steps_map"
        current-step="personal_information"
        sub-title=" - Personal Information"
    >
        <personal-information-content 
            :property="property"
            :states="states"
            :application="application"
            :test_users="testUsers"
            :applicant_type="applicant_type"
            :recent_application="recent_application"
            :experian_attempt="experian_attempt"
            :step_completion_status="$page.props.step_completion_status"
            :step_progress_data="$page.props.step_progress_data"
            :completed_steps_map="$page.props.completed_steps_map"
        />
    </application-layout>
</template>

<script>
import ApplicationLayout from './ApplicationLayout.vue';
import PersonalInformationContent from './PersonalInformationContent.vue';

export default {
    components: {
        ApplicationLayout,
        PersonalInformationContent,
    },
    props: {
        property: Object,
        states: Object,
        application: Object,
        testUsers: Object,
        applicant_type: String,
        recent_application: Object,
        experian_attempt: Object,
        step_completion_status: Object,
        step_progress_data: Object,
        completed_steps_map: Object,
    },
}
</script>